import { LearningOpportunityUserStatus } from "@/server/backend-api/generated";
import { UserAdmissionData } from "@/server/backend-api/learningOpportunityUserAdmission";

type ProgressItem = {
  status: LearningOpportunityUserStatus;
  date?: string | null;
};

export const createAdmissionProgressItems = (
  userAdmission: UserAdmissionData
): ProgressItem[] => {
  if (!userAdmission?.createdDate) return [];

  const {
    status,
    createdDate,
    deniedDate,
    offeredDate,
    offerDueDate,
    offerResponseDate,
  } = userAdmission;

  const showOfferedCard =
    status === LearningOpportunityUserStatus.OfferedToLearner ||
    status === LearningOpportunityUserStatus.LearnerAttending ||
    status === LearningOpportunityUserStatus.LearnerRejectedOffer ||
    status === LearningOpportunityUserStatus.OfferToLearnerExpired ||
    status === LearningOpportunityUserStatus.LearnerCompleted ||
    status === LearningOpportunityUserStatus.LearnerFailed ||
    status === LearningOpportunityUserStatus.LearnerDroppedOut;

  const items: ProgressItem[] = [
    { date: createdDate, status: LearningOpportunityUserStatus.LearnerApplied },
  ];

  if (showOfferedCard) {
    items.unshift({
      date: offeredDate,
      status: LearningOpportunityUserStatus.OfferedToLearner,
    });
  }

  if (
    status === LearningOpportunityUserStatus.LearnerAttending ||
    status === LearningOpportunityUserStatus.LearnerCompleted
  ) {
    items.unshift({ date: offerResponseDate, status: status });
  }
  // TODO: Map to completed for now. Maybe change in the future?
  if (
    status === LearningOpportunityUserStatus.LearnerDroppedOut ||
    status === LearningOpportunityUserStatus.LearnerFailed
  ) {
    items.unshift({
      date: offerResponseDate,
      status: LearningOpportunityUserStatus.LearnerCompleted,
    });
  }
  if (status === LearningOpportunityUserStatus.LearnerRejectedOffer) {
    items.unshift({ date: offerResponseDate, status: status });
  }

  if (
    status === LearningOpportunityUserStatus.AdmissionOfficerDeniedApplication
  ) {
    items.unshift({ date: deniedDate, status: status });
  }
  if (status === LearningOpportunityUserStatus.OfferToLearnerExpired) {
    items.unshift({ date: offerDueDate, status: status });
  }

  return items;
};
